import { math } from 'polished';
import { css } from 'styled-components';

/**
 * Fakes rounded CSS outline in Safari using a pseudo element border.
 *
 * This workaround is needed, because Safari prior version 16.4 doesn't respect
 * border-radius when rendering CSS outline.
 *
 * To use this polyfill the element needs to have `position: relative` or
 * `position: absolute` set in its styles.
 *
 * @param borderRadius Element border-radius
 * @param borderWidth Element boder-width
 * @param outlineColor Outline color
 * @param outlineOffset Outline offset including
 * @param outlineWidth Outline thickness
 * @returns CSS for a pseudo element faking outline using a border
 * @see https://jira.sok.fi/browse/SDS-1045
 */
const safariRoundedOutlinePolyfill = ({ borderRadius, borderWidth, outlineColor, outlineOffset, outlineWidth, }) => {
    const edge = math(`-1 * (${outlineWidth} + ${outlineOffset} + ${borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0})`);
    const outlineRadius = borderRadius && parseFloat(borderRadius) > 0
        ? math(`${outlineWidth} + ${outlineOffset} + ${borderRadius}`)
        : undefined;
    // @supports rule is used here to detect Safari, as it is currently
    // the only Webkit-based browser supporting and requiring a vendor prefix
    // for `hyphens` property. https://caniuse.com/?search=-webkit-hyphens
    return css `
        @supports (-webkit-hyphens: none) {
            outline: none;

            &:after {
                border: ${outlineWidth} solid ${outlineColor};
                border-radius: ${outlineRadius};
                bottom: ${edge};
                content: '';
                left: ${edge};
                position: absolute;
                right: ${edge};
                top: ${edge};
            }
        }
    `;
};

export { safariRoundedOutlinePolyfill };
//# sourceMappingURL=polyfill.js.map
